// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"4afa9c3f","159":"1f40819f","453":"4bc1e226","675":"ea1d32c9","825":"eed8823d","867":"5c59d5fa"}[chunkId] + ".chunk.js";
};